// @flow
import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Link } from 'react-router'
import MediaQuery from 'react-responsive'
import { User } from '../../types'
import colors from '../../styles/colors'
import zindex from '../../styles/zindex'
import media from '../../styles/media'
import { logout } from '../../actions/session'
import BuyDropdown from '../BuyDropdown'
import SellDropdown from '../SellDropdown'
import Button from '../Button'
import UserDropdown from '../UserDropdown'

const Component = styled.nav`
  display: flex;
  flex-wrap: wrap;
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: ${zindex.navbar};
`

const TopContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 1rem;
  position: relative;

  &::after {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #e1e6eb 50%, transparent);
    content: '';
  }

  ${media.mdUp} {
    &::after {
      display: none;
    }
  }
`

const Telephone = styled.a`
  height: 100%;
  display: none;
  align-items: center;
  padding: 0 1rem;

  &:hover,
  &:focus {
    text-decoration: none;
  }

  ${media.smUp} {
    display: flex;
  }
`

const NavLink = styled(Link)`
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  transition: box-shadow 0.2s;
  color: rgb(120, 130, 140);
  margin-right: 0.5rem;

  &:hover {
    box-shadow: inset 0 -3px ${colors.primary};
  }

  &:hover,
  &:focus {
    color: rgb(100, 110, 120);
    text-decoration: none;
  }
`

const Logo = styled.img`
  height: 25px;

  ${media.mdUp} {
    height: 35px;
  }
`

type Props = {
  user: User,
  logout: Function,
  isAuthenticated: boolean
}

const LinkList = styled.div`
  display: flex;
  align-items: center;
  ${media.smDown} {
    justify-content: center;
    height: 45px;
    width: 100%;
  }
  ${media.mdUp} {
    height: 100%;
    width: auto;
  }
`

const NavLinks = () => (
  <LinkList>
    <BuyDropdown />
    <SellDropdown />
    <NavLink to="/agents">Team</NavLink>
  </LinkList>
)

const Navbar = (
  { isAuthenticated, logout, user }: Props // eslint-disable-line no-shadow
) => (
  <Component>
    <TopContainer>
      <Link to="/">
        <Logo src="/static/images/logo-sm.png" alt="Kief Realty" />
      </Link>
      <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
        <Telephone href="tel:217-379-2222">
          <span className="fa fa-phone" style={{ marginRight: '5px' }} />
          <span>217-379-2222</span>
        </Telephone>
        <MediaQuery query="(min-width: 768px)">
          <NavLinks />
        </MediaQuery>
        {!isAuthenticated && (
          <Button small to="/login" style={{ margin: '0 1rem' }}>
            Login
          </Button>
        )}
        {!isAuthenticated && (
          <Button small color="primary" to="/signup">
            Sign up
          </Button>
        )}
        {isAuthenticated && <UserDropdown user={user} onLogout={logout} />}
      </div>
    </TopContainer>
    <MediaQuery query="(max-width: 767px)" style={{ background: '#fff' }}>
      <NavLinks />
    </MediaQuery>
  </Component>
)

export default connect(
  (state) => ({
    user: state.session.currentUser,
    isAuthenticated: state.session.isAuthenticated
  }),
  {
    logout
  }
)(Navbar)



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js